import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
import { resetAllUserStores } from '@/stores/reset-all'
import { pushToast } from '@/composables/useToast'
import { appConfig } from '@/config/env'
// naive-ui 组件按子路径局部 import 在各自的 view / composable；本文件无需注册。
import '@fontsource-variable/noto-sans-sc/wght.css'
import './styles/tokens.css'
import './styles/animations.css'
import './styles/base.css'
import './styles/layout.css'
import './styles/components.css'
import './styles/views.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

document.documentElement.classList.add('js-reveal')

router.afterEach((to) => {
  const base = to.meta.title?.trim() || appConfig.title
  document.title = base === appConfig.title ? appConfig.title : `${base} - ${appConfig.title}`
})

const auth = useAuthStore(pinia)
void auth.restore()

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

window.addEventListener('xuntu:auth-expired', () => {
  resetAllUserStores()
  const currentPath = router.currentRoute.value.fullPath
  if (router.currentRoute.value.name !== 'login') {
    void router.push({ name: 'login', query: { redirect: currentPath } })
  }
})

window.addEventListener('xuntu:error-toast', (event) => {
  const detail = (event as CustomEvent<{ message?: string }>).detail
  if (detail?.message) pushToast(detail.message)
})

app.mount('#app')
